import React from "react";

/** Footer for useIncrementalList: auto-loads more when scrolled into view, with a manual fallback. */
export function ListSentinel({ sentinelRef, hasMore, visibleCount, total, onShowMore, noun = "bills" }) {
  if (total === 0) return null;

  return (
    <div
      ref={hasMore ? sentinelRef : undefined}
      style={{ textAlign: "center", fontSize: "0.75rem", color: "var(--text-dim)", padding: "0.75rem 0 1.25rem" }}
    >
      {hasMore ? (
        <>
          Showing {visibleCount} of {total} {noun} •{" "}
          <button
            type="button"
            onClick={onShowMore}
            style={{ background: "none", border: "none", color: "var(--primary)", fontWeight: "700", cursor: "pointer", padding: 0, fontSize: "0.75rem" }}
          >
            Show more
          </button>
        </>
      ) : (
        total > 10 && <>All {total} {noun} shown</>
      )}
    </div>
  );
}

export default ListSentinel;
